import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-todo-popup',
  templateUrl: './todo-popup.component.html',
  styleUrls: ['./todo-popup.component.scss']
})
export class TodoPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
